module.exports = __webpack_public_path__ + "static/media/articles.460530c0.png";